import { actionCreatorFactory } from "typescript-fsa";

const createAction = actionCreatorFactory("HCP_SPECIFIC_MESSAGING");

export const updateGenericFilter = createAction<string>("UPDATE_GENERIC_FILTER", (genericFilter: string) => {
  return genericFilter;
});
